import { DataLayer } from "@grandvisionhq/analytics";
const eventName = "returns_click";
const siteFeature = "order_returns_flow";
const pushReturnsEvent = (event) => {
  const { interactionType, items } = event;
  DataLayer.pushEvent({
    event: eventName,
    site_feature: siteFeature,
    interaction_type: interactionType,
    ...items ? { items } : null
  });
};
export {
  eventName,
  pushReturnsEvent,
  siteFeature
};
//# sourceMappingURL=returns.js.map
